import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'tireTreadwear',
  title: 'Tire Treadwears',
  type: 'document',
  fields: [
    defineField({
      name: 'value',
      title: 'Value',
      type: 'number',
      validation: (Rule) =>
        Rule.custom(async (value, context) => {
          if (!value) return true
          if (!context.document?._id) return true

          const {getClient} = context
          const client = getClient({apiVersion: '2023-05-03'})

          const query = `*[
            _type == "tireTreadwear" &&
            value == $value &&
            _id != $currentId &&
            _id != $currentDraftId
          ][0]`

          const params = {
            value: value,
            currentId: context.document._id.replace('drafts.', ''),
            currentDraftId: `drafts.${context.document._id.replace('drafts.', '')}`,
          }

          const existing = await client.fetch(query, params)
          return existing
            ? 'This treadwear value already exists. Please use a unique value.'
            : true
        }),
    }),
  ],
  preview: {
    select: {
      title: 'value',
    },
    prepare(selection) {
      const { title } = selection
      return {
        title: `${title}`,
      }
    },
  },
  orderings: [
    {
      title: 'Treadwear Value, High to Low',
      name: 'valueDesc',
      by: [{ field: 'value', direction: 'desc' }],
    },
  ],
})
